import Swal from 'sweetalert2';
import moment from 'moment';
import { mapGetters } from 'vuex';
import TasksCalendar from './TasksCalendar';
import TasksTimeline from './TasksTimeline';
import TasksProgress from './TasksProgress';
export default {
  name: 'Tasks',
  props: {
    projectId: {
      type: Number,
      required: true
    }
  },
  created() {
    this.$store.dispatch('tasks/fetchTasks', {
      projectID: this.projectId
    });
  },
  mounted() {
    jQuery(this.$refs.calendarTab).on('shown.bs.tab', this.calendarShown.bind(this));
  },
  methods: {
    onEventsCalendarClick(event) {
      const html = `
                <p>
                    ${event.extendedProps.description}
                </p>
                ${moment(event.start).format('MMMM DD, YYYY')}
            `;
      Swal.fire({
        html,
        icon: 'info',
        title: event.title,
        iconHtml: '<i class="far fa-calendar-alt"></i>',
        confirmButtonText: 'Close'
      });
    },
    calendarShown() {
      if (this.$refs.calendarWidget) {
        this.$refs.calendarWidget.resize();
      }
    }
  },
  computed: {
    ...mapGetters('tasks', ['tasksTimestamp']),
    downloadCalendar() {
      return `/tables/projects/${this.projectId}/calendar`;
    }
  },
  components: {
    TasksCalendar,
    TasksTimeline,
    TasksProgress
  }
};